import React from "react";
import { PageHero, PageBody } from "./_shared";
import { useBul } from "./BulLayout";
import PublicAcademicsPage from "@/components/PublicAcademicsPage";

export default function Academics() {
  const data = useBul();
  const docs = data.academics || [];
  return (
    <div data-testid="bul-ac-wrap">
      <PageHero eyebrow="Academic Resources" title="Academics" />
      <PageBody>
        <PublicAcademicsPage docs={docs} theme="cream" testidPrefix="bul-ac" />
      </PageBody>
    </div>
  );
}
